import React from 'react';
import { WithT } from 'i18next';
import { REGULARS } from 'utils';
import { IColumn, UserPhoto } from 'components';
import { IClient } from '../../clients/models';

export const generateClientColumns = (t: WithT['t']): IColumn[] => [
	{
		name: 'name',
		label: <div>{t('table.name')}</div>,
		cellRenderer: ({ logoUrl, shortName }: IClient) => {
			return (
				<div className="cell-content">
					<UserPhoto
						logoUrl={logoUrl}
						logoClass="cell-content__logo cell-content__logo--with-name"
						placeholderClass="cell-content__logo cell-content__logo--with-name"
					/>
					<div className="cell-content__text">{shortName}</div>
				</div>
			);
		},
	},
	{
		name: 'website',
		label: <div>{t('table.website')}</div>,
		cellRenderer: ({ website }: IClient) => {
			const matchProtocol = REGULARS.protocol.test(website);
			return (
				<div>
					<a
						href={matchProtocol ? website : `https://${website}`}
						target="_blank"
						rel="noopener noreferrer"
					>
						{website}
					</a>
				</div>
			);
		},
	},
	{
		name: 'limit',
		label: <div>{t('table.limit')}</div>,
		cellRenderer: ({ surveyCountLimit }: IClient) => {
			return <div>{surveyCountLimit}</div>;
		},
	},
	{
		name: 'mailing_list',
		label: <div>{t('table.mailing_list')}</div>,
		cellRenderer: ({ employeesCount }: IClient) => {
			return <div>{employeesCount}</div>;
		},
	},
];
